import React from 'react';
import { withRouter } from 'inferno-router';
import { DateTime } from 'luxon';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
} from './components/base_components';
import { BusyComponent, BusyOverlay } from './components/busy_component';
import ProgressSpinner from './components/progress_spinner';

import ClientVersionStore from './stores/client_version_store';

const styles = StyleSheet.create({
  clientVersionScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '3em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  line: {
    alignSelf: 'stretch',
    height: '1px',
    backgroundColor: 'black',
  },
  headerText: {
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  title: {
    marginTop: '1em',
    marginBottom: '0.5em',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  list: {
    marginBottom: '1em',
    flexDirection: 'column',
  },
  clientHeader: {
    paddingLeft: '0.5em',
    height: '2em',
    backgroundColor: '#eee',
    borderBottom: '1px solid #999',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  client: {
    paddingLeft: '0.5em',
    height: '4em',
    justifyContent: 'flex-start',
    alignItems: 'center',
    ':hover': {
      backgroundColor: 'lightblue',
    },
  },
  odd: {
    backgroundColor: '#eee',
  },
  hostname: {
    marginRight: '1em',
    width: '10em',
    fontWeight: 'bold',
  },
  status: {
    marginRight: '1em',
    width: '6em',
  },
  statusOld: {
    marginRight: '1em',
    width: '6em',
    color: 'red',
    fontWeight: 'bold',
  },
  statusCurrent: {
    marginRight: '1em',
    width: '6em',
    color: 'green',
  },
  time: {
    marginRight: '1em',
    width: '10em',
  },
  ips: {
    display: 'block',
    marginRight: '1em',
    width: '20em',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  hash: {
    width: '10em',
  },
});

type Props = {
  match: any;
};
type State = {
  avid_fs_version_list: any | null;
  abt_media_sync_version_list: any | null;
};

class ClientVersionScreen extends BusyComponent<Props, State> {
  state = {
    avid_fs_version_list: null,
    abt_media_sync_version_list: null,
  };
  componentDidMount() {
    ClientVersionStore.addChangeListener(this._onClientVersionUpdate);
    ClientVersionStore.fetch();
    this._onClientVersionUpdate();
  }
  componentWillUnmount() {
    ClientVersionStore.addChangeListener(this._onClientVersionUpdate);
  }
  _onClientVersionUpdate = () => {
    const avid_fs_version_list = ClientVersionStore.getVersionList('avid-fs');
    const abt_media_sync_version_list = ClientVersionStore.getVersionList(
      'abt-media-sync'
    );
    this.setState({ avid_fs_version_list, abt_media_sync_version_list });
  };
  render() {
    const { avid_fs_version_list, abt_media_sync_version_list } = this.state;

    let content = null;
    if (!avid_fs_version_list || !abt_media_sync_version_list) {
      content = <ProgressSpinner />;
    } else {
      const avids = avid_fs_version_list.map((c, i) => (
        <Client key={i} client={c} odd={i % 2 === 1} />
      ));
      const medias = abt_media_sync_version_list.map((c, i) => (
        <Client key={i} client={c} odd={i % 2 === 1} />
      ));

      content = (
        <>
          <Text style={styles.title}>Project Drive Software:</Text>
          <Line />
          <View style={styles.list}>
            <ClientHeader />
            {avids}
          </View>
          <Text style={styles.title}>Media Drive Software:</Text>
          <Line />
          <View style={styles.list}>
            <ClientHeader />
            {medias}
          </View>
          <Line />
        </>
      );
    }
    return (
      <View style={styles.clientVersionScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Text style={styles.headerText}>MONP ABT</Text>
          <Line />
          {content}
        </ScrollView>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}
export default withRouter(ClientVersionScreen);

function Line() {
  return <View style={styles.line} />;
}

function ClientHeader() {
  return (
    <View style={styles.clientHeader}>
      <Text style={styles.hostname}>Hostname</Text>
      <Text style={styles.status}>Status</Text>
      <Text style={styles.time}>Last Seen</Text>
      <Text style={styles.ips}>IPs</Text>
      <Text style={styles.hash}>Current Hash</Text>
      <Text style={styles.hash}>Upgrade Hash</Text>
    </View>
  );
}

function Client(props) {
  const { client, odd } = props;
  const {
    hostname,
    needs_update,
    last_updated,
    git_hash,
    ip_list,
    update_git_hash,
  } = client;
  console.log(client);
  const status = needs_update ? (
    <Text style={styles.statusOld}>Old</Text>
  ) : (
    <Text style={styles.statusCurrent}>Current</Text>
  );

  const ips = ip_list
    .split(',')
    .sort(_sortIps)
    .join(', ');
  const dt = DateTime.fromISO(last_updated);
  const date = dt.toFormat('yyyy-MM-dd HH:mm:ss');

  const odd_style = odd ? styles.odd : styles.even;

  const current = git_hash && git_hash.slice(0, 7);
  const target = update_git_hash && update_git_hash.slice(0, 7);
  return (
    <View style={[styles.client, odd_style]}>
      <Text style={styles.hostname}>{hostname}</Text>
      {status}
      <Text style={styles.time}>{date}</Text>
      <Text style={styles.ips} title={ips}>
        {ips}
      </Text>
      <Text style={styles.hash}>{current}</Text>
      <Text style={styles.hash}>{target}</Text>
    </View>
  );
}

function _sortIps(a, b) {
  if (a.startsWith('100.')) {
    return -1;
  } else if (b.startsWith('100.')) {
    return 1;
  } else {
    return a.localeCompare(b);
  }
}
